import "@assets/css/skeleton.css";

export const BranchCardSkeleton = () => {
  return (
    <div className="col-xl-3 col-lg-6 mt-4">
      <div className="card border-0 shadow-sm h-100 overflow-hidden">
        <div className="position-relative">
          <div className="shimmer" style={{ height: 160, width: "100%" }} />
          <div className="position-absolute top-0 end-0 m-2">
            <div
              className="shimmer"
              style={{ height: 28, width: 80, borderRadius: 20 }}
            />
          </div>
          <div className="position-absolute" style={{ left: 16, bottom: -28 }}>
            <div
              className="shimmer rounded-circle"
              style={{ width: 64, height: 64 }}
            />
          </div>
        </div>
        <div className="card-body pt-4">
          <div
            className="shimmer"
            style={{ height: 24, width: "70%", marginBottom: 8 }}
          />
          <div
            className="shimmer"
            style={{ height: 18, width: "80%", marginBottom: 8 }}
          />
          <div
            className="shimmer"
            style={{ height: 18, width: "50%", marginBottom: 12 }}
          />
          <div className="d-flex flex-wrap gap-1 mt-2">
            <div
              className="shimmer"
              style={{ height: 24, width: 60, borderRadius: 20 }}
            />
            <div
              className="shimmer"
              style={{ height: 24, width: 60, borderRadius: 20 }}
            />
            <div
              className="shimmer"
              style={{ height: 24, width: 60, borderRadius: 20 }}
            />
          </div>
        </div>
        <div className="card-footer bg-transparent border-0">
          <div className="shimmer" style={{ height: 16, width: "60%" }} />
        </div>
      </div>
    </div>
  );
};
